import { useState } from "react";

const socials = [
  { name: "TWITTER", href: "https://twitter.com" },
  { name: "DRIBBBLE", href: "https://dribbble.com" },
  { name: "BEHANCE", href: "https://behance.net" },
];

const navItems = ["Home", "About", "Works", "Contact"];

export default function Navbar() {
  const [active, setActive] = useState("Home");

  return (
    <nav className="w-full bg-white">
      <div className="relative mx-auto max-w-[1440px] px-8 py-6 flex items-center justify-between">
        {/* Left: socials */}
        <div className="flex items-center gap-7">
          {socials.map((s) => (
            <a
              key={s.name}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="group flex items-center gap-1.5 text-[12px] font-semibold tracking-[0.15em] text-ink hover:opacity-70 transition-opacity cursor-pointer whitespace-nowrap"
            >
              {s.name}
              <i className="ri-arrow-right-up-line text-base transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          ))}
        </div>

        {/* Center: two-line logo */}
        <a
          href="/"
          className="absolute left-1/2 -translate-x-1/2 text-center leading-[1.05] cursor-pointer"
          aria-label="Accord Portfolio home"
        >
          <div className="font-display text-[15px] tracking-[0.18em] text-ink">ACCORD</div>
          <div className="font-display text-[15px] tracking-[0.18em] text-ink">PORTFOLIO</div>
        </a>

        {/* Right: nav */}
        <ul className="flex items-center gap-9">
          {navItems.map((item) => {
            const isActive = active === item;
            return (
              <li key={item}>
                <a
                  href={`#${item.toLowerCase()}`}
                  onClick={(e) => {
                    e.preventDefault();
                    setActive(item);
                  }}
                  className={`text-[12px] font-semibold tracking-[0.18em] uppercase text-ink cursor-pointer whitespace-nowrap pb-1 border-b-2 transition-colors ${
                    isActive ? "border-ink" : "border-transparent hover:border-ink/40"
                  }`}
                >
                  {item}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}